export const LOG_INTERVAL = 60 * 1000;

export interface Logger {
    debug: LogFn
    info: LogFn
    warn: LogFn
    error: LogFn
}

export interface LogFn {
    (msg: string | Object, obj?: Record<string, unknown>): void;
}